import { useEffect, useState } from "react";
import { Icon, type IconName } from "./Icon";
import { cx, Spinner } from "./primitives";

// §11/D155 — gemeinsame 7×7-Row-Vorschau, 1:1 geteilt von den FolderTree-Asset-Zeilen (D142) UND
// der Jobs-Liste, damit beide Listen IDENTISCH aussehen. Zeigt entweder ein presigntes Thumbnail
// (object-cover) oder — fehlt die URL — einen Fallback: ein kind-/Status-Icon bzw. einen Spinner
// (laufender Job). Schlägt das Bild fehl (abgelaufene presigned URL, D56), wird auf das Icon
// zurückgefallen. `danger` färbt den Icon-Rahmen rot (fehlgeschlagener Job).

export function MediaThumb({
  url,
  icon = "image",
  spinner = false,
  danger = false,
}: {
  /** Presignte Bild-URL; fehlt sie (oder lädt sie nicht), greift der Icon-/Spinner-Fallback. */
  url?: string | null;
  /** Fallback-Icon, wenn kein Bild gezeigt wird. */
  icon?: IconName;
  /** Statt eines Icons einen Spinner zeigen (laufender Job). */
  spinner?: boolean;
  /** Roter Rahmen/Icon (fehlgeschlagener Zustand). */
  danger?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  // Wechselt die URL (frische presigned URL nach Delta-Sync), den Fehler-Latch zurücksetzen.
  useEffect(() => setFailed(false), [url]);

  if (url && !failed) {
    return (
      <img
        src={url}
        alt=""
        draggable={false}
        onError={() => setFailed(true)}
        className="h-7 w-7 shrink-0 rounded border border-border object-cover"
      />
    );
  }
  return (
    <span
      className={cx(
        "grid h-7 w-7 shrink-0 place-items-center rounded border",
        danger ? "border-danger/40 text-danger" : "border-border",
      )}
    >
      {spinner ? <Spinner size={14} /> : <Icon name={icon} size={13} />}
    </span>
  );
}
